import { useEffect, useState } from "react";
import { useDevice } from "~/lib/hooks/useDevice";

export const useLockBodyScroll = (
	lockedOnDesktop: boolean | undefined = false,
	neverlocked = false,
) => {
	const [isLocked, setIsLocked] = useState<boolean>(false);
	const [hydrated, setHydrated] = useState<boolean>(false);
	const { desktop } = useDevice();

	useEffect(() => {
		setHydrated(true);

		return () => {
			setHydrated(false);
		};
	}, []);

	const lockBodyScroll = () => {
		if (neverlocked || (!lockedOnDesktop && desktop)) return;
		if (!hydrated) return;
		setIsLocked(true);

		if (typeof document === "undefined") return;

		document.body.classList.add("scroll-locked");
		if (lockedOnDesktop) {
			document.body.classList.add("desktop-locked");
		}
	};

	const unlockBodyScroll = () => {
		if (neverlocked || (!lockedOnDesktop && desktop)) return;
		if (!hydrated) return;
		setIsLocked(false);
		if (typeof document === "undefined") return;
		document.body.classList.remove("scroll-locked");
		if (lockedOnDesktop) {
			document.body.classList.remove("desktop-locked");
		}
	};

	const toggleBodyScroll = () => {
		if (neverlocked || (!lockedOnDesktop && desktop)) return;
		if (!hydrated) return;
		if (isLocked) {
			lockBodyScroll();
		} else {
			unlockBodyScroll();
		}
	};

	return { isLocked, unlockBodyScroll, lockBodyScroll, toggleBodyScroll };
};
